
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: {
      title: 'Home',
      meta: [
        { vmid: 'description', name: 'description', content: 'YOOXPLORE UAVs feature exclusive Anti-Jamming and Flight Without GNSS capabilities, enabling stable reconnaissance in complex interference environments. We offer complete UAV systems, standalone anti-jamming modules, and comprehensive solutions to counter anti-drone equipment. Actively recruiting agents, distributors, and factory partners worldwide.' },
        { vmid: 'keywords', name: 'keywords', content: 'YOOXPLORE, UAV, drone, anti-jamming drone, GNSS-free flight, FPV, counter-UAS, anti-drone, reconnaissance drone, drone manufacturer, drone distributor, drone module' },
      ],
      script: [
        {
          vmid: 'org-jsonld',
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'YOOXPLORE',
            url: 'https://yooxplore.com',
            logo: {
              '@type': 'ImageObject',
              url: 'https://yooxplore.com/img/logo.png',
              width: 497,
              height: 41,
            },
            description: 'YOOXPLORE manufactures advanced UAV systems with Anti-Jamming and GNSS-Denied flight capabilities. We also provide standalone anti-jamming modules for FPV fleet upgrades and recruit global agents, distributors, and factory partners.',
            sameAs: [], // 可以添加社交媒体链接
          },
        },
        {
          vmid: 'website-jsonld',
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'YOOXPLORE',
            url: 'https://yooxplore.com',
          },
        },
      ],
    },

    extends: View,

    mixins: [
      LoadSections([
        'hero',
        'scenarios',
        'core-advantages',
        'product-center',
        'about-us-new',
        'keep-in-touch2', // 联系我们
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },

    async mounted() {
      await this.loadSectionsByModules()
    },

    methods: {
      async loadSectionsByModules() {
        const baseSections = ['hero', 'product-center', 'keep-in-touch2']
        try {
          const modules = await this.$axios({
            method: 'get',
            url: '/public/modules/page/home',
            params: { lang: this.$i18n.locale },
          })

          if (!Array.isArray(modules) || modules.length === 0) {
            this.sections = baseSections
            return
          }

          const enabledModuleKeySet = new Set(
            modules
              .filter(item => item && item.enabled !== false && this.hasModuleContent(item))
              .map(item => item.moduleKey)
              .filter(Boolean),
          )

          const dynamicSections = []
          if (enabledModuleKeySet.has('scenarios')) {
            dynamicSections.push('scenarios')
          }
          if (enabledModuleKeySet.has('advantages')) {
            dynamicSections.push('core-advantages')
          }
          if (enabledModuleKeySet.has('about_us')) {
            dynamicSections.push('about-us-new')
          }

          this.sections = [
            ...baseSections.slice(0, 1),
            ...dynamicSections,
            ...baseSections.slice(1),
          ]
        } catch (error) {
          this.sections = baseSections
        }
      },
      hasModuleContent(module) {
        if (!module) return false
        return Boolean(
          String(module.title || '').trim() ||
            String(module.subtitle || '').trim() ||
            String(module.content || '').trim(),
        )
      },
    },
  }
</script>
